import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/evaluator")({
  component: () => (
    <Breadcrumb label="Evaluator" to="/content/evaluator">
      <Outlet />
    </Breadcrumb>
  ),
});
